import MD5 from 'crypto-js/md5'

export default function (str1, str2 = '', hash = '3b7bd52387baff9fb4dd8433cce4961c') {
    if (typeof str1 !== 'string' || typeof str2 !== 'string') throw new Error('The parameter types must be string!')
    return MD5(str1.trim() + str2.trim() + hash).toString()
}